import FeedMappings from './FeedMappings';

export default FeedMappings;
